const ACCESS_TOKEN_STORAGE_KEY = `${process.env.REACT_APP_BASE_STORAGE_KEY}_token`

/**
 * getUserIdFromToken
 * Reads the JWT access token stored in localStorage and extracts the user id (`sub` claim).
 * Does not verify the token signature: it is only used to identify whose browser session
 * we are in, the server remains the source of truth for authorization.
 * @returns {number|null} User id from the stored access token, or null if absent/invalid
 */
export default function getUserIdFromToken() {
    if (typeof window === 'undefined')
        return null

    try {
        const token = window.localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY)

        if (!token)
            return null

        const [, payload] = token.split('.')

        if (!payload)
            return null

        const decodedPayload = JSON.parse(window.atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
        const userId = Number(decodedPayload?.sub)

        return Number.isFinite(userId) ? userId : null
    } catch (error) {
        return null
    }
}
